<template>
  <b-container fluid="sm">
    <h3 v-if="contentID === 19 || contentID === 20">
      {{ widgetName }} dashboard text
    </h3>
    <template v-if="contentID != 19 && contentID != 20">
      <div>
        <div>
          <b-form-group>
            <h3 v-if="!isEditWidgetName">{{ widgetName }} widget settings</h3>
            <b-form-input
              v-if="isEditWidgetName"
              v-model="widgetName"
              minlength="1"
              maxlength="50"
            ></b-form-input>
            <div class="err-msg" v-if="ifWidgetName">
              Please enter widget name
            </div>
            <span>
              <b-button @click="edit" v-if="!isEditWidgetName" variant="primary"
                >Edit</b-button
              >
            </span>
          </b-form-group>
        </div>

        <div>
          <b-form-group>
            <b-form-checkbox
              v-if="tblDashboards"
              v-model="displayWidget"
              name="check-button"
              switch
              >Show/Hide widget in the dashboard</b-form-checkbox
            >
          </b-form-group>
          <b-form-group>
            <b-form-checkbox v-model="notifyUser" name="check-button"
              >Notify Users</b-form-checkbox
            >
          </b-form-group>
        </div>

        <div>
          <b-row class="col mb-3">
            <!--<b-col></b-col>-->
            <p>Add a logo</p>
            <div class="col-6">
              <b-form-file
                v-model="logoFile"
                placeholder="Choose a svg file or drop it here..."
                drop-placeholder="Drop file here..."
                accept="image/svg+xml,.svg"
                @change="changeWidgetLogo"
              ></b-form-file>
            </div>
          </b-row>
        </div>
      </div>
    </template>

    <div>
      <h5 align="left">Dashboard text - Registered address</h5>
      <editor
        v-model="registeredContent"
        :api-key="tinyEditorApiKey"
        :init="tinyEditorInitConfig"
      />
      <!-- <vue-editor v-model="registeredContent" /> -->
      <div class="copyBtn" align="right">
        <b-button @click="copyToAllForms" variant="primary"
          >Copy to all forms</b-button
        >
      </div>
      <template v-if="contentID != 19 && contentID != 20">
        <h5 align="left">Dashboard text - No Registered address</h5>
        <editor
          v-model="unRegisteredContent"
          :api-key="tinyEditorApiKey"
          :init="tinyEditorInitConfig"
        />
      </template>
      <!-- <vue-editor v-model="unRegisteredContent" /> -->
      <h5 align="left">Expanded view - Registered address</h5>
      <editor
        v-model="registeredContentExpanded"
        :api-key="tinyEditorApiKey"
        :init="tinyEditorInitConfig"
      />
      <!-- <vue-editor v-model="registeredContentExpanded" /> -->
      <template v-if="contentID != 19 && contentID != 20">
        <h5 align="left">Expanded view - No Registered address</h5>
        <editor
          v-model="unRegisteredContentExpanded"
          :api-key="tinyEditorApiKey"
          :init="tinyEditorInitConfig"
        />
        <!-- <vue-editor v-model="unRegisteredContentExpanded" /> -->
      </template>
      <div align="right">
        <b-button variant="outline-primary" @click="cancelAll" class="cancel"
          >Cancel</b-button
        >
        <b-button @click="updateTemplate" variant="primary">Update</b-button>
      </div>
    </div>
  </b-container>
</template>

<script>
import { VueEditor } from "vue2-editor";
import Editor from "@tinymce/tinymce-vue";
import { HTTP } from "./../helpers/http-common";
import { APIURLS } from "./../helpers/apiUrls";

export default {
  name: "Editor",
  props: {
    selectedId: Number,
    selectedObj: Array,
    title: "Welcome to title changer",
  },

  components: { VueEditor, editor: Editor },

  data() {
    return {
      customToolbar: [["image"]],
      // file: "",
      widgetLogo: "",
      logoFile: null,

      widgetName: "",
      displayWidget: null,
      notifyUser: null,
      registeredContent: "",
      registeredContentExpanded: "",
      unRegisteredContent: "",
      unRegisteredContentExpanded: "",
      widgetDetailResponse: null,
      tblDashboards: null,
      dashboardID: null,
      isEditWidgetName: false,
      ifWidgetName: false,
      tinyEditorApiKey: "tmkr90atqt0tzb1w14w5iq5t19u2smyqzcu4ye43c8ghs4jq",
      tinyEditorInitConfig: {
        statusbar: false,
        plugins:
          "print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons",
        imagetools_cors_hosts: ["picsum.photos"],
        menubar: "file edit view insert format tools table help",
        toolbar:
          "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl",
        toolbar_sticky: true,
        autosave_ask_before_unload: true,
        autosave_interval: "30s",
        autosave_prefix: "{path}{query}-{id}-",
        autosave_restore_when_empty: false,
        autosave_retention: "2m",
        image_advtab: true,
        link_list: [
          { title: "My page 1", value: "http://www.tinymce.com" },
          { title: "My page 2", value: "http://www.moxiecode.com" },
        ],
        image_list: [
          { title: "My page 1", value: "http://www.tinymce.com" },
          { title: "My page 2", value: "http://www.moxiecode.com" },
        ],
        image_class_list: [
          { title: "None", value: "" },
          { title: "Some class", value: "class-name" },
        ],
        importcss_append: true,
        file_picker_callback: function (callback, value, meta) {
          /* Provide file and text for the link dialog */
          if (meta.filetype === "file") {
            callback("https://www.google.com/logos/google.jpg", {
              text: "My text",
            });
          }

          /* Provide image and alt text for the image dialog */
          if (meta.filetype === "image") {
            callback("https://www.google.com/logos/google.jpg", {
              alt: "My alt text",
            });
          }

          /* Provide alternative source and posted for the media dialog */
          if (meta.filetype === "media") {
            callback("movie.mp4", {
              source2: "alt.ogg",
              poster: "https://www.google.com/logos/google.jpg",
            });
          }
        },
        templates: [
          {
            title: "New Table",
            description: "creates a new table",
            content:
              '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>',
          },
          {
            title: "Starting my story",
            description: "A cure for writers block",
            content: "Once upon a time...",
          },
          {
            title: "New list with dates",
            description: "New List with dates",
            content:
              '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>',
          },
        ],
        template_cdate_format: "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
        template_mdate_format: "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
        height: 500,
        image_caption: true,
        quickbars_selection_toolbar:
          "bold italic | quicklink h2 h3 blockquote quickimage quicktable",
        noneditable_noneditable_class: "mceNonEditable",
        toolbar_mode: "sliding",
        contextmenu: "link image imagetools table",
        content_style:
          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
      },
    };
  },
  mounted() {
    this.getContentWidgetDetails();
  },
  created() {
    setInterval(function () {
      sessionStorage.clear();
      window.location.reload();
    }, 600000);
  },
  methods: {
    getContentWidgetDetails() {
      const [selectedObj] = this.selectedObj;
      HTTP.get(`${APIURLS.getContentWidgetDetails}/${selectedObj.DashboardID}`)
        .then((response) => {
          this.widgetLogo = response.data.widgetLogo;
          this.widgetName = response.data.widget;

          this.displayWidget = response.data.display;
          this.tblDashboards = response.data;
        })
        .catch((error) => {});

      HTTP.get(`${APIURLS.ContentWidgets}/${selectedObj.ContentID}`)

        .then((response) => {
          this.widgetDetailResponse = response.data;
          this.registeredContent = response.data.registeredContent;
          this.registeredContentExpanded =
            response.data.registeredContentExpanded;
          this.unRegisteredContent = response.data.unRegisteredContent;
          this.unRegisteredContentExpanded =
            response.data.unRegisteredContentExpanded;
          this.contentID = response.data.contentID;
          this.notifyUser = response.data.isNotified;
        })
        .catch((error) => {});
    },
    changeWidgetLogo(ev) {
      if (ev.target.files && ev.target.files.length) {
        const fileName = ev.target.files[0].name;
        const idxDot = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
        if (extFile == "svg") {
          const reader = new FileReader();
          reader.readAsText(ev.target.files[0]);
          reader.onload = (event) => {
            this.widgetLogo = event.target.result;
          };
        } else {
          this.$bvModal.msgBoxOk("Only SVG files are allowed!", {
            title: "Warning",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
          ev.target.value = "";
        }
      }
    },
    updateTemplate() {
      this.ifWidgetName = false;
      const [selectedObj] = this.selectedObj;
      const {
        widgetDetailResponse,
        registeredContent,
        registeredContentExpanded,
        unRegisteredContent,
        unRegisteredContentExpanded,
        tblDashboards,
        widgetName,
        displayWidget,
        notifyUser,
        widgetLogo,
      } = this;

      const data = {
        contentWidgets: {
          contentID: widgetDetailResponse.contentID,
          createdBy: widgetDetailResponse.createdBy,
          createdOn: widgetDetailResponse.createdOn,
          dashboardID: widgetDetailResponse.dashboardID,
          lastModifiedBy: widgetDetailResponse.createdBy,
          lastModifiedOn: new Date(),
          registeredContent,
          registeredContentExpanded,
          unRegisteredContent,
          unRegisteredContentExpanded,
          isNotified: notifyUser,
        },
        dashboard: {
          id: this.tblDashboards.id,
          widget: widgetName,
          display: displayWidget,

          widgetIndex: null,
          widgetCategoryId: 0,
          widgetCode: null,
          contentWidget: true,
          widgetLogo: widgetLogo,
          lastModifiedBy: widgetDetailResponse.createdBy,
          createdBy: widgetDetailResponse.createdBy,
        },
      };

      if (this.widgetName == "" || this.widgetName.trim().length == 0) {
        this.ifWidgetName = true;
        window.scrollTo(0, 0);
      }
      if (this.ifWidgetName != true) {
        HTTP.put(`${APIURLS.updateTemplate}`, data)
          // headers: {
          //   "Content-Type": "multipart/form-data",
          // },

          .then((response) => {
            alert("Updated Successfully");
            this.getContentWidgetDetails();
            this.widgetLogo = "";
          })
          .catch((error) => {
            alert(error.response.data.Message);
          });
      }
    },

    edit() {
      this.isEditWidgetName = true;
    },

    cancelAll() {
      this.widgetName = this.tblDashboards.widget;
      this.isEditWidgetName = false;
      this.displayWidget = this.tblDashboards.display;
      this.registeredContent = this.widgetDetailResponse.registeredContent;
      this.registeredContentExpanded = this.widgetDetailResponse.registeredContentExpanded;
      this.unRegisteredContent = this.widgetDetailResponse.unRegisteredContent;
      this.unRegisteredContentExpanded = this.widgetDetailResponse.unRegisteredContentExpanded;
    },

    copyToAllForms() {
      this.$confirm("The content in the boxes will be overwritten?").then(
        () => {
          this.registeredContentExpanded = this.registeredContent;
          this.unRegisteredContent = this.registeredContent;
          this.unRegisteredContentExpanded = this.registeredContent;
          //do something...
        }
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.logo_upload {
  //height: 0 !important;
  overflow: inherit !important;
  width: 127px !important;
}
.copyBtn {
  margin-left: 0px;
}
.cancel {
  margin-right: 35px;
}
// .quillWrapper{
//   height: 10px;
//   overflow: hidden;
// }
.err-msg {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  float: left;
  text-align: left;
}
</style>
